import React from 'react';

import fetchSchedule from './helpers/fetchSchedule';
import Track from './Track';
import Item from './Item';
import Modal from './Modal';

import { HOUR_HEIGHT, HOUR_WIDTH, START_HOUR, HOURS } from './helpers/constants';

import './ScheduleComponent.scss';

export default class ScheduleComponent extends React.Component {
  state = {
    locations: [],
    items: [],
    currentDay: 0,
    category: 'All Categories',
    selectedItem: null
  };
  ref = null;
  constructor(props) {
    super(props);
  }
  generateHeaders(locations) {
    let top = 0;
    const headers = [];
    for (const { rows, key } of locations) {
      top += rows.length;
      headers.push(<h3 
        key={key} 
        className="sc__timeline__track__header" 
        style={{top: top * HOUR_HEIGHT, width: rows.length * HOUR_HEIGHT}}
        >
        {key}
        </h3>);
    }
    return headers;
  }
  onScrollDelayed = () => {
    const day = Math.floor(((this.ref.scrollLeft / HOUR_WIDTH) + 2 + START_HOUR) / 24);
    if (day != this.state.currentDay) {
      this.setState({ currentDay: day });
    }
  }
  onScroll = (e) => {
    window.requestAnimationFrame(this.onScrollDelayed);
  }
  attachScrollListener = (ref) => {
    if (this.ref !== null) this.ref.removeEventListener('scroll', this.onScroll);
    this.ref = ref;
    this.ref.addEventListener('scroll', this.onScroll);
  }
  goToDay(day) {
    if (this.ref !== null) this.ref.scrollLeft = Math.max(0, ((day * 24) - START_HOUR) * HOUR_WIDTH);
  } 
  generateHours() {
    const hours = [];
    for (let i = 0; i < HOURS; i++) {
      const hour = (i + START_HOUR) % 24;
      const visibleHour = hour % 12;
      hours.push(
        <div key={i} className="sc__timeline__track__hour" style={{left: i * HOUR_WIDTH}}>
          {visibleHour == 0 ? 12 : visibleHour}{hour < 12 ? 'AM' : 'PM'}
        </div>
      );
    }
    return (
      <div className="sc__timeline__track" style={{height: HOUR_HEIGHT, borderBottom: 'none'}}>
        { hours }
      </div>
    );
  }
  onCategoryChange = (e) => {
    this.setState({ category: e.target.value });
  }
  closeModal = () => {
    this.setState({ selectedItem: null });
  }
  selectItem = (item) => {
    this.setState({ selectedItem: item });
  }
  componentDidMount() {
    if (window.HackerAPI) fetchSchedule().then(({ locations, items }) => this.setState({ locations, items }));
  }
  render() {
    const { locations, items, currentDay, category, selectedItem } = this.state;
    return (<React.Fragment>
      <h2>Event Schedule</h2>
      <div className="sc">
        { items.length === 0 ? <div className="sc__loading">Loading Schedule...</div> : null }
        <div className="sc__header">
          <div className="sc__header__days">
            <button onClick={this.goToDay.bind(this, 0)} className={currentDay === 0 ? 'active' : ''}>Day 1</button>
            <button onClick={this.goToDay.bind(this, 1)}className={currentDay === 1 ? 'active' : ''}>Day 2</button>
            <button onClick={this.goToDay.bind(this, 2)}className={currentDay === 2 ? 'active' : ''}>Day 3</button>
          </div>
        </div>
        <div className="sc__timeline">
          <div className="sc__timeline__container" ref={this.attachScrollListener}>
            {locations.map(({ key, rows }) => (<Track selectItem={this.selectItem} expectedCategory={category} key={key} name={key} rows={rows} />))}
            {this.generateHours()}
          </div>
          {this.generateHeaders(locations)}
        </div>
        <div className="sc__categories">
          <select value={category} onChange={this.onCategoryChange}>
            <option value="All Categories">All Categories</option>
            <option value="Main Events">Main Events</option>
            <option value="Food">Food</option>
            <option value="Activities">Activities</option>
            <option value="Workshops">Workshops</option>
            <option value="Tech Talks">Tech Talks</option>
          </select>
        </div>
        <div className="sc__list">
          { items.map((item, idx) => (
            <React.Fragment key={item.absStartHour + item.name}>
              { (idx == 0 || items[idx - 1].start.day != item.start.day) ? 
                (
                  <div className="sc__list__item sc__list__item--day">
                    <h4>Day {item.start.day - 13} - {item.start.weekdayShort} Sept {item.start.day}</h4>
                  </div>
                ) : 
                null }
              <Item selectItem={this.selectItem} expectedCategory={category} {...item} />
            </React.Fragment>
          )) }
        </div>
      </div>
      <Modal visible={selectedItem !== null} {...(selectedItem || {})} onClose={this.closeModal} />
    </React.Fragment>);
  }
}


// WEBPACK FOOTER //
// ./src/components/Schedule/ScheduleComponent/index.jsx